import { ConfigProvider } from 'antd';
import useKeyboardShortcut from 'use-keyboard-shortcut';
import { useModal } from '@/hooks';
import { AppModal } from '@/components';
import DevToolContent from './DevToolContent';

export default function DevTool() {
  const { open, hide, toggle } = useModal();

  useKeyboardShortcut(
    ['Control', '/'], toggle,
    {
      overrideSystem: true,
      ignoreInputFields: false,
      repeatOnHold: false
    }
  );

  return (
    <ConfigProvider direction="ltr">
      <AppModal
        open={open}
        onCancel={hide}
        footer={null}
        title="DevTool"
        variant="glass"
        className="ltr font-mono"
        destroyOnClose
      >
        <DevToolContent hide={hide} />
      </AppModal>
    </ConfigProvider>
  );
}
